// ============================================================
// NAVEGACIÓN
// ------------------------------------------------------------
// REGLA ÚNICA: aquí solo entran destinos que EXISTEN.
//
// El menú tenía 7 items (Finance, Credit, AI, Software, Rewards,
// Learn, About) apuntando a anclas inexistentes. Cinco de esas
// verticales no tienen ni una página escrita. Un menú que promete
// seis secciones y entrega una destruye la confianza, que es
// justamente lo que Blinkblis vende.
//
// Cuando Finance tenga 3 artículos, Finance vuelve al menú.
// Se gana el lugar, no se reserva.
// ============================================================

import type { Lang } from '../offers/config'

export type NavItem = {
  label: Record<Lang, string>
  path: string
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: { es: 'Crédito', en: 'Credit' },
    path: '/oferta/credito',
  },
  {
    label: { es: 'Metodología', en: 'Methodology' },
    path: '/metodologia',
  },
  {
    label: { es: 'Cómo trabajamos', en: 'How we work' },
    path: '/divulgacion-de-afiliados',
  },
]

// ============================================================
// FOOTER
// El footer sí puede listar más, porque nadie espera que el pie
// de página sea un índice de contenido — pero tampoco enlaza a
// nada que no exista. null = no se muestra.
// ============================================================

// Orden en i18n: 0 Finance · 1 Credit · 2 AI · 3 Software · 4 Rewards
export const FOOTER_PLATFORM: (string | null)[] = [
  null, // Finance   — sin contenido
  '/oferta/credito', // Credit    — la única viva
  null, // AI        — sin contenido
  null, // Software  — sin contenido
  null, // Rewards   — sin contenido
]

// Orden en i18n: 0 About · 1 Careers · 2 Contact · 3 Press
export const FOOTER_COMPANY: (string | null)[] = [
  '/estandares-editoriales', // About -> quiénes somos se explica aquí
  null, // Careers
  'mailto:insights@blinkblis.com', // Contact
  null, // Press
]

// Orden en i18n: 0 Editorial Standards · 1 Methodology
// 2 Affiliate Disclosure · 3 Privacy · 4 Terms · 5 Contact
export const FOOTER_LEGAL: (string | null)[] = [
  '/estandares-editoriales',
  '/metodologia',
  '/divulgacion-de-afiliados',
  '/privacidad',
  '/terminos',
  'mailto:insights@blinkblis.com',
]

export const isExternal = (path: string) =>
  path.startsWith('mailto:') || path.startsWith('http') || path.startsWith('/#')
